import { useContext, useState, useEffect } from "react";
import { Context } from "../context/DataContext";
import SearchBox from "../components/common/SearchBox";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import PersonIcon from "@material-ui/icons/Person";
import { RemoveAccents, printAmount } from "../functions";
import MonthlyMenu from "../components/MonthlyMenu";
import { Link } from "react-router-dom";
import BottomNavigationPanel from "../components/BottomNavigationPanel";
import { UseCustomerList } from "../server/fetcher";
import Loading from "../components/Loading";
import Modal from "react-bootstrap/Modal";

const Monthly = () => {
  const { state } = useContext(Context);
  const { user } = state;
  const [currentData, setCurrentData] = useState([]);
  const [monthlyAmount, setMonthlyAmount] = useState([]);
  const [monthlyCount, setMonthlyCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [modalData, setModalData] = useState({});

  const { data: customers, isLoading } = UseCustomerList(user.user_id);

  useEffect(() => {
    if (isLoading) return;

    const current = customers.filter((x) => +x.monthly > 0);
    setCurrentData(current);

    setMonthlyAmount(
      current.reduce((acc, obj) => {
        return +obj.monthly > 0 ? acc + +obj.monthly : acc;
      }, 0)
    );

    setMonthlyCount(
      current.reduce((acc, obj) => {
        return +obj.monthly > 0 ? acc + 1 : acc;
      }, 0)
    );

    //eslint-disable-next-line
  }, [customers]);

  if (isLoading) return <Loading />;

  const filterCustomers = (customers) => {
    let filtered = customers;

    if (searchText.length > 2) {
      filtered = filtered.filter((m) => RemoveAccents(m.search).toUpperCase().indexOf(searchText.toUpperCase()) >= 0);
      return filtered.slice(0, 5);
    }

    return filtered.slice(0, 200);
  };

  const handleDataClick = (data) => {
    setModalData(data);
  };

  const handleSearch = (query) => {
    setSearchText(query);
  };

  const filtered = filterCustomers(currentData);

  return (
    <>
      {monthlyAmount === 0 ? (
        <div className="container mt-5 mb-5">
          <Typography variant="h5" componet="h3" gutterBottom>
            Clientes Mensual!
          </Typography>
          <Typography variant="body1" componet="p" paragraph>
            En esta pagina puede ver todo los clientes mensual.
          </Typography>
        </div>
      ) : (
        <div className="mt-3">
          <Box component="div" p={1}>
            <Typography variant="h6" component="h4">
              <span>
                Clientes Mensuales: ({monthlyCount}) {printAmount(monthlyAmount)}
              </span>
            </Typography>

            <SearchBox onChange={handleSearch} placeHolder="Escriba para buscar Prestamo..." value={searchText} />
          </Box>

          <div className="mb-5">
            <table className="table table-sm">
              <thead>
                <tr>
                  <th scope="col">Nombre</th>
                  <th scope="col">Mensual</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((customer) => (
                  <tr key={customer.customer_id}>
                    <td>
                      <Typography variant="subtitle2" component="p" className="font-weight-bold">
                        <Link style={{ color: "#000" }} to={`/payment/${customer.customer_id}`}>
                          <PersonIcon /> {customer.name}
                        </Link>
                      </Typography>
                    </td>
                    <td>{printAmount(customer.monthly)}</td>
                    <td>
                      <MonthlyMenu customer={customer} handleDataClick={handleDataClick} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <Modal
        show={modalData.name ? true : false}
        onHide={() => setModalData({})}
        backdrop="static"
        keyboard={false}
        centered>
        <Modal.Header>
          <Modal.Title>
            <Typography variant="h6">
              {modalData.name}
              {/* <b className="p-2">
                    <Chip label={`C${modalData.debtor_id}`} />
                  </b> */}
            </Typography>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Typography variant="h6" component="h3" className="text-danger">
            Confirmaci&oacute;n
          </Typography>

          <Typography variant="h6" component="h4" gutterBottom></Typography>

          <ul className="list-group list-group-flush">
            <li className="list-group-item">
              <Typography variant="body1" component="h4">
                Mensualidad {printAmount(modalData.monthly)}
              </Typography>
            </li>

            <li className="list-group-item">
              <Typography variant="body1" component="h4">
                Balance {printAmount(modalData.balance)}
              </Typography>
            </li>
          </ul>

          <Box paddingTop={2}>
            <Typography variant="h6" component="h4" gutterBottom>
              Decea borrar este cliente?
            </Typography>
            <br />
            <Button fullWidth variant="contained" color="secondary">
              Borrar Cliente
            </Button>
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setModalData({})}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>

      <br />
      <BottomNavigationPanel customers={customers} />
    </>
  );
};

export default Monthly;
